export const returnLabel = (list, version, featrue) => {
    const labelList = JSON.parse(
        JSON.stringify(list.map((item) => item.labelName))
    );
    let exchangeList = [];
    if (labelList.length < 3) {
        exchangeList = labelList;
    } else {
        exchangeList = labelList.filter((item) => item !== version);
        exchangeList = exchangeList.filter((item) => item !== featrue);
    }
    return exchangeList.join("/");
};
